export default {
  callIntent(action, parameter) {
    const a = document.createElement('a');
    const skillId = 'amzn1.ask.skill.0f26244c-7411-4c2c-8401-d808c57eedef';
    const task = 'PlayQuestionOfTheDay';
    const task_version = '1';
    let url = `https://alexa-skills.amazon.com/apis/custom/skills/${skillId}/tasks/${task}/versions/${task_version}?action=${action}`;
    if (parameter) {
      const params_s = encodeURIComponent(parameter);
      url += '&parameter=' + params_s;
    }
    a.setAttribute('href', url);
    a.click();
  }
};
